import { render, staticRenderFns } from "./PurchaseHistoryListings.vue?vue&type=template&id=63428afe"
import script from "./PurchaseHistoryListings.vue?vue&type=script&lang=js"
export * from "./PurchaseHistoryListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports